var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-review-block-small klantenvertellen-block-small"},[(_vm.hasRating)?_c('div',{staticClass:"grade"},[_c('a',{attrs:{"href":_vm.viewLink,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.score)+"\n      ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }